<!-- Header -->
<h3 mat-dialog-title>
  Classic Login Not Available
</h3>

<!-- Body -->
<mat-dialog-content>
  <span>You only have permission to log into 360.</span>
</mat-dialog-content>

<!-- Footer -->
<mat-dialog-actions style="position: sticky">
  <div class="footerRight">
      <tyl-button image="save black.png" label="OK" (clickEvent)="ok()"></tyl-button>
  </div>
</mat-dialog-actions>